import React from "react"
import CryptoCurrency from "../components/CryptoCurrency"

const Cryptocurrencies = () => {
  return (
    <>
      <CryptoCurrency />
    </>
  )
}

export default Cryptocurrencies
